import Main from './OrdersMain'

const order = { Main }

export default order
